angular.module('aq.filters.transformers')
.filter("first", function() {
    return function(input, n) {
        return _.first(input, n);
    }
});